import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faLocation, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="resortFooter">
      <div className="footerOverlay">
        <div className="container">
          <div className="footerContainer">
            {/* LEFT SECTION */}
            <div className="footerLeft">
              <div className="footerLogo">
                <img
                  src="/assets/images/logo/logo.png"
                  alt="Jaltaara"
                  className="footer_logo"
                />
                <p>Explore The Nature</p>
              </div>
            </div>

            {/* QUICK LINKS */}
            <div className="footerColumn">
              <h4>Quick Links</h4>
              <ul>
                <Link to={"/"}>
                  <li>Home</li>
                </Link>
                <Link to={"/about-us"}>
                  <li>About Us</li>
                </Link>
                <Link to={"/gallery"}>
                  <li>Gallery</li>
                </Link>
                <Link to={"/contact-us"}>
                  <li>Contact</li>
                </Link>

                <Link to={"/terms-of-use"}>
                  <li>Terms of use</li>
                </Link>
                <Link to={"/privacy-policy"}>
                  <li>Privacy</li>
                </Link>
                <Link to={"/environmental-policy"}>
                  <li>Environmental Policy</li>
                </Link>
              </ul>
            </div>

            {/* CONTACT */}
            <div className="footerColumn">
              <h4>Contact Us</h4>
              <ul className="contactList">
                <li>
                  {" "}
                  <FontAwesomeIcon icon={faLocation} />
                  At Post Tetali Tal. Jawali Dist. Satara. (New Mahabaleshwar)
                </li>
                <li>
                  <FontAwesomeIcon icon={faEnvelope} /> hoteljaltaaraa@gmail.com

                </li>
                <li>
                  <FontAwesomeIcon icon={faPhone} /> 9404320245 / 9011550390
                </li>
              </ul>
            </div>
          </div>

          {/* COPYRIGHT */}
          <div className="footerBottom">
            <p>Copyright © Jaltaara, All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
